import { template, flow } from 'lodash';

const createEncodedSocialMessage = (spyRole, spyRoleArticle, spyRoleUrl) => messageTemplate => flow(
  [
    template(messageTemplate),
    encodeURIComponent,
  ],
)({ spyRole, spyRoleArticle, spyRoleUrl });

export const selectSocialNetworks = (
  spyRole,
  spyRoleArticle,
  spyRoleUrl,
  {
    whatsApp: whatsAppMessageTemplate,
    twitter: twitterMessageTemplate,
  },
) => {
  const createMessage = createEncodedSocialMessage(spyRole, spyRoleArticle, spyRoleUrl);
  const whatsAppMessage = createMessage(whatsAppMessageTemplate);
  const twitterMessage = createMessage(twitterMessageTemplate);
  const isMobile = /\bMobi/i.test(navigator.userAgent);
  const instagramIcon = {
    id: 'Instagram',
    url: '#',
  };

  return [
    {
      id: 'Facebook',
      url: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(spyRoleUrl)}`,
    },
    {
      id: 'Twitter',
      url: `https://twitter.com/intent/tweet?text=${twitterMessage}`,
    },
    {
      id: 'WhatsApp',
      url: `https://api.whatsapp.com/send?text=${whatsAppMessage}`,
    },
    ...(isMobile ? [instagramIcon] : []),
  ];
};
